import { useEffect, useState } from "react";

export const useBtns = ({ allPages, numPages }) => {
  const [allBtns, setAllBtns] = useState([]);
  useEffect(() => {
    let btns = [];
    for (let i = 0; i < allPages; i++) {
      btns.push(i);
    }
    setAllBtns(btns);
  }, [allPages, numPages]);
  return { allBtns };
};
